
import React, { useState, useRef } from 'react';
import './addCertificate.css';
import { useNavigate } from 'react-router-dom';

const AddCertificate = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    price: '',
    description: '',
    gst: '',
    days: '',
    aboutCourse: '',
    eligibility: '',   // ✅ Added eligibility
    courseIncludes: '',
    courseExcludes: '',
    image: null,
  });

  const [submitting, setSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'image' && files.length > 0) {
      const file = files[0];
      if (!file.type.startsWith('image/')) {
        alert('Please upload a valid image file');
        return;
      }
      setFormData({ ...formData, image: file });
      setPreview(URL.createObjectURL(file));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && formData[key] !== '') {
        data.append(key, formData[key]);
      }
    });

    try {
      const res = await fetch(process.env.REACT_APP_API_URL+"/api/certificates", {
        method: "POST",
        body: data,
      });

      if (res.ok) {
        alert("✅ Certificate Submitted Successfully!");
        setFormData({
          name: '',
          price: '',
          description: '',
          gst: '',
          days: '',
          aboutCourse: '',
          eligibility: '',   // reset eligibility too
          courseIncludes: '',
          courseExcludes: '',
          image: null
        });
        setPreview(null);
        if (fileInputRef.current) fileInputRef.current.value = null;
        navigate('/admin/certificates?refresh=1');
      } else {
        const errorData = await res.json();
        alert("❌ Failed to submit certificate: " + (errorData.message || res.statusText));
      }
    } catch (error) {
      console.error("Error submitting certificate:", error);
      alert("❌ Server error");
    }
    setSubmitting(false);
  };

  return (
    <div className="add-certificate-container">
      <header className="add-header">
        <img src="/flytutor_logo.png" alt="FlyTutor Logo" className="flytutor-logo" />
        <h1 className="panel-title">Admin Panel</h1>
      </header>

      <div className="form-wrapper">
        <div className="admin-name">
          <span className="label">Admin Name :</span> <span className="admin">Sanjay</span>
        </div>

        <form className="certificate-form" onSubmit={handleSubmit}>
          <label>
            Certificate Name :
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </label>

          <label>
            Price :
            <input type="number" name="price" value={formData.price} onChange={handleChange} required />
          </label>

          <label>
            Description :
            <textarea name="description" value={formData.description} onChange={handleChange} required />
          </label>

          <label>
            GST :
            <input type="text" name="gst" value={formData.gst} onChange={handleChange} required />
          </label>

          <label>
            Days :
            <input type="number" name="days" value={formData.days} onChange={handleChange} required />
          </label>

          {/* ✅ Extra fields */}
          <label>
            About Course :
            <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} required />
          </label>

          <label>
            Eligibility :
            <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} required />
          </label>

          <label>
            Course Includes :
            <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} required />
          </label>

          <label>
            Course Excludes :
            <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} required />
          </label>

          <label>
            Add Image :
            <input
              type="file"
              name="image"
              onChange={handleChange}
              ref={fileInputRef}
              accept="image/*"
            />
          </label>

          {preview && (
            <div style={{ marginTop: 10 }}>
              <img src={preview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? 'Submitting...' : 'SUBMIT'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCertificate;
